// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__jFRl0","face":"style_face__SsXfh","empty":"style_empty__0XZLb","status":"style_status__rxzYl","kycBtn":"style_kycBtn__i+hT-"};